import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { teacherPanelAPI } from '../../services/api';
import { 
  Users, 
  BookOpen,
  GraduationCap,
  Loader2,
  ChevronRight
} from 'lucide-react';

const TeacherHome = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['teacher-dashboard'],
    queryFn: () => teacherPanelAPI.getDashboard(),
  });

  const stats = data?.data?.stats;
  const groups = data?.data?.groups || [];
  const subjects = data?.data?.subjects || [];
  const teacher = data?.data?.teacher;

  if (isLoading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error">
        Ma'lumotlarni yuklashda xatolik yuz berdi
      </div>
    );
  }

  return (
    <>
      {/* Welcome */}
      <div className="welcome-card">
        <div className="welcome-text">
          <h2>Xush kelibsiz, {teacher?.user?.full_name}!</h2>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon orange">
            <Users size={28} />
          </div>
          <div className="stat-info">
            <h3>{stats?.total_groups || 0}</h3>
            <p>Mening guruhlarim</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon purple">
            <BookOpen size={28} />
          </div>
          <div className="stat-info">
            <h3>{stats?.total_subjects || 0}</h3>
            <p>Mening fanlarim</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon blue">
            <GraduationCap size={28} />
          </div>
          <div className="stat-info">
            <h3>{stats?.total_students || 0}</h3>
            <p>Jami talabalar</p>
          </div>
        </div>
      </div>

      {/* Content Grid */}
      <div className="content-grid">
        {/* My Groups */}
        <div className="card">
          <div className="card-header">
            <h3>Mening guruhlarim</h3>
            <Link to="/teacher/groups" className="link-btn">
              Barchasi <ChevronRight size={16} />
            </Link>
          </div>
          <div className="card-body">
            {groups.length === 0 ? (
              <div className="empty-state small">
                <Users size={32} />
                <p>Guruhlar biriktirilmagan</p>
              </div>
            ) : (
              <div className="list-items">
                {groups.slice(0, 5).map(group => (
                  <Link 
                    key={group.id} 
                    to={`/teacher/groups/${group.id}/students`}
                    className="list-item clickable"
                  >
                    <div className="list-item-icon">
                      <Users size={20} />
                    </div>
                    <div className="list-item-content">
                      <div className="list-item-title">{group.name}</div>
                      <div className="list-item-subtitle">{group.course}-kurs</div>
                    </div>
                    <div className="list-item-badge">
                      {group.students_count} talaba
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* My Subjects */}
        <div className="card">
          <div className="card-header">
            <h3>Mening fanlarim</h3>
            <Link to="/teacher/subjects" className="link-btn">
              Barchasi <ChevronRight size={16} />
            </Link>
          </div>
          <div className="card-body">
            {subjects.length === 0 ? (
              <div className="empty-state small">
                <BookOpen size={32} />
                <p>Fanlar biriktirilmagan</p>
              </div>
            ) : (
              <div className="list-items">
                {subjects.slice(0, 5).map(subject => (
                  <div key={subject.id} className="list-item">
                    <div className="list-item-icon purple">
                      <BookOpen size={20} />
                    </div>
                    <div className="list-item-content">
                      <div className="list-item-title">{subject.name}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherHome;
